export default "__VITE_ASSET__7Xg6Rdeg__"